import {createContext, useContext, type ReactNode} from 'react';
import type {FormApi} from '@/hooks/useForm';

// Shares a useForm() instance with the fields rendered inside it — the role Formik's context
// played for `useFormikContext`. Kept free of UI imports so MUI-free forms can use it; the MUI
// `FieldError` lives in FormContext.tsx, which re-exports everything here.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const FormContext = createContext<FormApi<any> | null>(null);

export const FormProvider = <V extends object>({form, children}: {form: FormApi<V>; children: ReactNode}) => (
    <FormContext.Provider value={form}>{children}</FormContext.Provider>
);

export const useFormContext = <V extends object>(): FormApi<V> => {
    const form = useContext(FormContext);
    if (!form) throw new Error('useFormContext must be used inside <FormProvider>');
    return form as FormApi<V>;
};
